exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-3f9c23dc]::after {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-3f9c23dc] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-3f9c23dc] {\n    color: red\n}\n.mt[data-v-3f9c23dc] {\n    margin-top: 7px;\n}\n.expiryClass[data-v-3f9c23dc] {\n    background-color: red\n}\n.gradientbt[data-v-3f9c23dc]{\n    background: #0F6940;\n    color: white\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3f9c23dc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/technician/TechnicianCreate.vue
// module id = 164
// module chunks = 0